export default __webpack_public_path__ + "static/media/backgroundmobile.0455224e.png";